module.exports = __webpack_public_path__ + "static/media/ML.2b9e75c0.png";